import {
  FETCH_TRANSFER_ORDER_DETAIL_PENDING,
  FETCH_TRANSFER_ORDER_DETAIL_REJECTED,
  FETCH_TRANSFER_ORDER_DETAIL_FULFILLED,
} from "../constants/transferOrderDetail";

const initialState = {
  pending: true,
  transferOrderDetail: {
    source: {},
    destination: {},
    state: {},
    shippingAddress: {},
  },
  error: {},
};

export const transferOrderDetail = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_TRANSFER_ORDER_DETAIL_PENDING:
      return { ...state, pending: true, error: [] };

    case FETCH_TRANSFER_ORDER_DETAIL_REJECTED:
      return { ...state, pending: false, error: action.error };

    case FETCH_TRANSFER_ORDER_DETAIL_FULFILLED:
      return {
        ...state,
        transferOrderDetail: action.data,
        pending: false,
        error: []
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/transferOrderDetail.js